import { useHistory } from 'react-router-dom';
import { HistoryDropdown } from '../../../../shared';
import { toHistoryDropdownItems } from '../preferenceHistoryEntries';
import { MajorHistoryItem } from '../types';

type HistoryDropdownProps = {
  testResults: MajorHistoryItem[];
  currentResultId: number;
  redirectPath: string;
};

const HistoryDropdownWrapper = ({
  testResults,
  currentResultId,
  redirectPath,
}: HistoryDropdownProps) => {
  const history = useHistory();

  const handleSelect = (id: string | number) => {
    if (id === currentResultId) {
      return;
    }

    history.push(`${redirectPath}/${id}${history.location.search || ''}`);
  };

  return (
    <HistoryDropdown
      items={toHistoryDropdownItems(testResults)}
      activeId={currentResultId}
      onSelect={handleSelect}
    />
  );
};

export default HistoryDropdownWrapper;
